import { array, object, string } from 'yup';
import { validationErrorMessages } from './messages';

export const TaxIdentifierSchema = array().of(
  object().shape({
    type: string().required(validationErrorMessages.type.defaultMessage),
    taxNumber: string().test(
      'required',
      validationErrorMessages.taxNumber.defaultMessage,
      (value, context) => !!value?.length || !!context.parent.redactedTaxNumber?.length,
    ),
  }),
);
